import Vue from "vue";
const moment = require("moment");
import router from "../../router";
import { deviceDetect } from "mobile-device-detect";

const getDefaultState = () => {
  return {
    isOperateur: false,
    isSuperAdmin: false,
    isAnimateur: false,
    isAdmin: false,
    isSuperviseur: false,
    isGroupe: false,
    isAuthenticated: false,
    user: { projets: [] },
    NotificationToken: "",
    projetSelected: {},
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_NotificationToken(state, payload) {
    state.NotificationToken = payload;
  },

  SET_IS_ANIMATEUR(state, payload) {
    state.isAnimateur = payload;
    state.isAuthenticated = payload;
    state.isSuperviseur = false;
    state.isAdmin = false;
  },
  SET_IS_SUPER_ADMIN(state, payload) {
    state.isSuperAdmin = payload;
    state.isAdmin = payload;
    state.isAuthenticated = payload;
  },
  SET_IS_ADMIN(state, payload) {
    state.isAdmin = payload;
    state.isAuthenticated = payload;
  },
  SET_IS_SUPERVISEUR(state, payload) {
    state.isSuperviseur = payload;
    state.isAuthenticated = payload;
  },
  SET_IS_OPERATEUR(state, payload) {
    state.isOperateur = payload;
    state.isAuthenticated = payload;
  },
  SET_IS_GROUPE(state, payload) {
    state.isGroupe = payload;
    state.isAuthenticated = payload;
  },
  SET_AUTHENTICATED(state, payload) {
    state.isAuthenticated = payload;
  },
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_PROJECT_SELECTED(state, payload) {
    state.projetSelected = payload;
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  setProjectSelected({ commit }, payload) {
    commit("SET_PROJECT_SELECTED", payload);
  },
  async setRoleStates({ commit }, { mutation }) {
    commit(mutation, true);
  },

  async setUser({ commit }, user) {
    commit("SET_USER", user);
  },

  async setIsAuthenticated({ commit }, payload) {
    commit("SET_AUTHENTICATED", payload);
  },

  async userLogin({ commit, dispatch }, { email, password }) {
    let self = this;
    commit("SET_AUTHENTICATED", false);
    commit("SET_USER", []);
    commit("SET_IS_SUPER_ADMIN", false);
    commit("SET_IS_ADMIN", false);
    commit("SET_IS_SUPERVISEUR", false);
    commit("SET_IS_OPERATEUR", false);
    commit("SET_IS_GROUPE", false);
    commit("SET_IS_ANIMATEUR", false);

    this._vm.$firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        //console.log("logged in", user.user.uid);

        // Status of User
        self._vm.$firebase
          .firestore()
          .collection("users")
          .doc(user.user.uid.toString())
          .set(
            {
              dateLastConnexion: Date.now(),
              status: "online",
              //osName:deviceDetect().osName,
              //browserName:deviceDetect().browserName
            },
            { merge: true }
          );

        //router.go(0);
        //setMessaging
        /*       if (user.isSuperviseur) {
          dispatch("Notifications/setMessaging", "from Auth userLogin", {
            root: true,
          });
        } */
      })
      .catch((error) => {
        console.log(error.message);
        let snackbar = {};
        snackbar.showSnackbar = true;
        snackbar.snackbarContent = error.message;
        commit("SET_USER", null);
        commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
      });
  },
  async userJoin({ commit }, { email, password }) {
    this._vm.$firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((user) => {
        commit("SET_USER", user);
        commit("SET_AUTHENTICATED", true);
      })
      .catch(() => {
        commit("SET_USER", null);
        commit("SET_AUTHENTICATED", false);
      });
  },

  async userSignOut({ commit, dispatch }) {
    let self = this;
    var userBeforelogout = self.state.Auth.user;

    console.log("Déconnecté");
    commit("SET_AUTHENTICATED", false);
    commit("SET_USER", []);
    commit("SET_IS_SUPER_ADMIN", false);
    commit("SET_IS_ADMIN", false);
    commit("SET_IS_SUPERVISEUR", false);
    commit("SET_IS_OPERATEUR", false);
    commit("SET_IS_GROUPE", false);
    commit("SET_IS_ANIMATEUR", false);
    dispatch("Utils/clearAllStores", "Logout", {
      root: true,
    });
    console.log("offline uid", userBeforelogout.uid);
    // Status of User
    this._vm.$firebase
      .firestore()
      .collection("users")
      .doc(userBeforelogout.uid.toString())
      .set(
        {
          status: "Offline",
          dateDeConnexion: Date.now(),
        },
        { merge: true }
      );

    this._vm.$firebase
      .auth()
      .signOut()
      .then(() => {
        //router.push("/login");
      })
      .catch((error) => {
        console.log(error);
        let snackbar = {};
        snackbar.showSnackbar = true;
        snackbar.snackbarContent = error.message;
        commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
      });
  },
};

const getters = {
  isSuperAdmin: (state) => {
    return state.isSuperAdmin;
  },
  isAdmin: (state) => {
    return state.isAdmin;
  },
  isSuperviseur: (state) => {
    return state.isSuperviseur;
  },
  isOperateur: (state) => {
    return state.isOperateur;
  },
  isGroupe: (state) => {
    return state.isGroupe;
  },
  isAuthenticated: (state) => {
    return state.user !== null && state.user !== undefined;
  },
  user: (state) => {
    return state.user;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
